const currencyListOptions = [
    { value: "USD", label: "United States Dollar", countryCode: "US" },
    { value: "EUR", label: "Euro", countryCode: "EU" },
    { value: "GBP", label: "British Pound Sterling", countryCode: "GB" },
    { value: "CAD", label: "Canadian Dollar", countryCode: "CA" },
    { value: "ARS", label: "Argentine Peso", countryCode: "AR" },
    { value: "AUD", label: "Australian Dollar", countryCode: "AU" },
    { value: "BRL", label: "Brazilian Real", countryCode: "BR" },
    { value: "CLP", label: "Chilean Peso", countryCode: "CL" },
    { value: "CNY", label: "Chinese Yuan", countryCode: "CN" },
    { value: "CYP", label: "Cypriot Pound", countryCode: "CY" },
    { value: "CZK", label: "Czech Republic Koruna", countryCode: "CZ" },
    { value: "DKK", label: "Danish Krone", countryCode: "DK" },
    { value: "EEK", label: "Estonian Kroon", countryCode: "EE" },
    { value: "HKD", label: "Hong Kong Dollar", countryCode: "HK" },
    { value: "HUF", label: "Hungarian Forint", countryCode: "HU" },
    { value: "ISK", label: "Icelandic Krona", countryCode: "IS" },
    { value: "INR", label: "Indian Rupee", countryCode: "IN" },
    { value: "JMD", label: "Jamaican Dollar", countryCode: "JM" },
    { value: "JPY", label: "Japanese Yen", countryCode: "JP" },
    { value: "LVL", label: "Latvian Lats", countryCode: "LV" },
    { value: "LTL", label: "Lithuanian Litas", countryCode: "LT" },
    { value: "MTL", label: "Maltese Lira", countryCode: "MT" },
    { value: "MXN", label: "Mexican Peso", countryCode: "MX" },
    { value: "NZD", label: "New Zealand Dollar", countryCode: "NZ" },
    { value: "NOK", label: "Norwegian Krone", countryCode: "NO" },
    { value: "PLN", label: "Polish Zloty", countryCode: "PL" },
    { value: "SGD", label: "Singapore Dollar", countryCode: "SG" },
    { value: "SKK", label: "Slovak Koruna", countryCode: "SK" },
    { value: "SIT", label: "Slovenian Tolar", countryCode: "SI" },
    { value: "ZAR", label: "South African Rand", countryCode: "ZA" },
    { value: "KRW", label: "South Korean Won", countryCode: "KR" },
    { value: "SEK", label: "Swedish Krona", countryCode: "SE" },
    { value: "CHF", label: "Swiss Franc", countryCode: "CH" },
    { value: "TWD", label: "Taiwan New Dollar", countryCode: "TW" },
    { value: "UYU", label: "Uruguayan Peso", countryCode: "UY" },
    { value: "MYR", label: "Malaysian Ringgit", countryCode: "MY" },
    { value: "BSD", label: "Bahamian Dollar", countryCode: "BS" },
    { value: "CRC", label: "Costa Rican Colon", countryCode: "CR" },
    { value: "RON", label: "Romanian Leu", countryCode: "RO" },
    { value: "PHP", label: "Philippine Peso", countryCode: "PH" },
    { value: "AED", label: "United Arab Emirates Dirham", countryCode: "AE" },
    { value: "VEB", label: "Venezuelan Bolivar", countryCode: "VE" },
    { value: "IDR", label: "Indonesian Rupiah", countryCode: "ID" },
    { value: "TRY", label: "Turkish Lira", countryCode: "TR" },
    { value: "THB", label: "Thai Baht", countryCode: "TH" },
    { value: "TTD", label: "Trinidad and Tobago Dollar", countryCode: "TT" },
    { value: "ILS", label: "Israeli New Sheqel", countryCode: "IL" },
    { value: "SYP", label: "Syrian Pound", countryCode: "SY" },
    { value: "XCD", label: "East Caribbean Dollar", countryCode: "LC" },
    { value: "COP", label: "Colombian Peso", countryCode: "CO" },
    { value: "RUB", label: "Russian Ruble", countryCode: "RU" },
    { value: "HRK", label: "Croatian Kuna", countryCode: "HR" },
    { value: "KZT", label: "Kazakhstani Tenge", countryCode: "KZ" },
    { value: "TZS", label: "Tanzanian Shilling", countryCode: "TZ" },
    { value: "SAR", label: "Saudi Riyal", countryCode: "SA" },
    { value: "NIO", label: "Nicaraguan Cordoba", countryCode: "NI" },
    { value: "LAK", label: "Laotian Kip", countryCode: "LA" },
    { value: "OMR", label: "Omani Rial", countryCode: "OM" },
    { value: "AMD", label: "Armenian Dram", countryCode: "AM" },
    { value: "CDF", label: "Congolese Franc", countryCode: "CD" },
    { value: "KPW", label: "North Korean Won", countryCode: "KP" },
    { value: "KES", label: "Kenyan Shilling", countryCode: "KE" },
    { value: "ZWD", label: "Zimbabwean Dollar", countryCode: "ZW" },
    { value: "KHR", label: "Cambodian Riel", countryCode: "KH" },
    { value: "MVR", label: "Maldivian Rufiyaa", countryCode: "MV" },
    { value: "GTQ", label: "Guatemalan Quetzal", countryCode: "GT" },
    { value: "BZD", label: "Belize Dollar", countryCode: "BZ" },
    { value: "BYR", label: "Belarusian Ruble (pre-2016)", countryCode: "BY" },
    { value: "LYD", label: "Libyan Dinar", countryCode: "LY" },
    { value: "DZD", label: "Algerian Dinar", countryCode: "DZ" },
    { value: "BIF", label: "Burundian Franc", countryCode: "BI" },
    { value: "GIP", label: "Gibraltar Pound", countryCode: "GI" },
    { value: "BOB", label: "Bolivian Boliviano", countryCode: "BO" },
    { value: "STD", label: "Sao Tome and Principe Dobra (pre-2018)", countryCode: "ST" },
    { value: "NGN", label: "Nigerian Naira", countryCode: "NG" },
    { value: "PGK", label: "Papua New Guinean Kina", countryCode: "PG" },
    { value: "ERN", label: "Eritrean Nakfa", countryCode: "ER" },
    { value: "MWK", label: "Malawian Kwacha", countryCode: "MW" },
    { value: "CUP", label: "Cuban Peso", countryCode: "CU" },
    { value: "GMD", label: "Gambian Dalasi", countryCode: "GM" },
    { value: "CVE", label: "Cape Verdean Escudo", countryCode: "CV" },
    { value: "BTN", label: "Bhutanese Ngultrum", countryCode: "BT" },
    { value: "UGX", label: "Ugandan Shilling", countryCode: "UG" },
    { value: "MAD", label: "Moroccan Dirham", countryCode: "MA" },
    { value: "MNT", label: "Mongolian Tugrik", countryCode: "MN" },
    { value: "LSL", label: "Lesotho Loti", countryCode: "LS" },
    { value: "TOP", label: "Tongan Pa'anga", countryCode: "TO" },
    { value: "SHP", label: "Saint Helena Pound", countryCode: "SH" },
    { value: "RSD", label: "Serbian Dinar", countryCode: "RS" },
    { value: "HTG", label: "Haitian Gourde", countryCode: "HT" },
    { value: "MGA", label: "Malagasy Ariary", countryCode: "MG" },
    { value: "MZN", label: "Mozambican Metical", countryCode: "MZ" },
    { value: "FKP", label: "Falkland Islands Pound", countryCode: "FK" },
    { value: "BWP", label: "Botswanan Pula", countryCode: "BW" },
    { value: "HNL", label: "Honduran Lempira", countryCode: "HN" },
    { value: "PYG", label: "Paraguayan Guarani", countryCode: "PY" },
    { value: "JEP", label: "Jersey Pound", countryCode: "JE" },
    { value: "EGP", label: "Egyptian Pound", countryCode: "EG" },
    { value: "LBP", label: "Lebanese Pound", countryCode: "LB" },
    { value: "ANG", label: "Netherlands Antillean Guilder", countryCode: "CW" },
    { value: "WST", label: "Samoan Tala", countryCode: "WS" },
    { value: "TVD", label: "Tuvaluan Dollar", countryCode: "TV" },
    { value: "GYD", label: "Guyanaese Dollar", countryCode: "GY" },
    { value: "GGP", label: "Guernsey Pound", countryCode: "GG" },
    { value: "NPR", label: "Nepalese Rupee", countryCode: "NP" },
    { value: "KMF", label: "Comorian Franc", countryCode: "KM" },
    { value: "IRR", label: "Iranian Rial", countryCode: "IR" },
    { value: "SRD", label: "Surinamese Dollar", countryCode: "SR" },
    { value: "TMM", label: "Turkmenistani Manat (pre-2009)", countryCode: "TM" },
    { value: "SZL", label: "Swazi Lilangeni", countryCode: "SZ" },
    { value: "MOP", label: "Macanese Pataca", countryCode: "MO" },
    { value: "BMD", label: "Bermudan Dollar", countryCode: "BM" },
    { value: "XPF", label: "CFP Franc", countryCode: "PF" },
    { value: "ETB", label: "Ethiopian Birr", countryCode: "ET" },
    { value: "JOD", label: "Jordanian Dinar", countryCode: "JO" },
    { value: "MDL", label: "Moldovan Leu", countryCode: "MD" },
    { value: "MRO", label: "Mauritanian Ouguiya (pre-2018)", countryCode: "MR" },
    { value: "YER", label: "Yemeni Rial", countryCode: "YE" },
    { value: "BAM", label: "Bosnia-Herzegovina Convertible Mark", countryCode: "BA" },
    { value: "AWG", label: "Aruban Florin", countryCode: "AW" },
    { value: "PEN", label: "Peruvian Nuevo Sol", countryCode: "PE" },
    { value: "VEF", label: "Venezuelan Bolivar Fuerte", countryCode: "VE" },
    { value: "SLL", label: "Sierra Leonean Leone", countryCode: "SL" },
    { value: "KYD", label: "Cayman Islands Dollar", countryCode: "KY" },
    { value: "AOA", label: "Angolan Kwanza", countryCode: "AO" },
    { value: "TND", label: "Tunisian Dinar", countryCode: "TN" },
    { value: "TJS", label: "Tajikistani Somoni", countryCode: "TJ" },
    { value: "SCR", label: "Seychellois Rupee", countryCode: "SC" },
    { value: "LKR", label: "Sri Lankan Rupee", countryCode: "LK" },
    { value: "DJF", label: "Djiboutian Franc", countryCode: "DJ" },
    { value: "GNF", label: "Guinean Franc", countryCode: "GN" },
    { value: "VUV", label: "Vanuatu Vatu", countryCode: "VU" },
    { value: "SDG", label: "Sudanese Pound", countryCode: "SD" },
    { value: "IMP", label: "Isle of Man Pound", countryCode: "IM" },
    { value: "GEL", label: "Georgian Lari", countryCode: "GE" },
    { value: "FJD", label: "Fijian Dollar", countryCode: "FJ" },
    { value: "DOP", label: "Dominican Peso", countryCode: "DO" },
    { value: "MUR", label: "Mauritian Rupee", countryCode: "MU" },
    { value: "MMK", label: "Myanma Kyat", countryCode: "MM" },
    { value: "LRD", label: "Liberian Dollar", countryCode: "LR" },
    { value: "BBD", label: "Barbadian Dollar", countryCode: "BB" },
    { value: "ZMK", label: "Zambian Kwacha", countryCode: "ZM" },
    { value: "VND", label: "Vietnamese Dong", countryCode: "VN" },
    { value: "UAH", label: "Ukrainian Hryvnia", countryCode: "UA" },
    { value: "TMT", label: "Turkmenistani Manat", countryCode: "TM" },
    { value: "IQD", label: "Iraqi Dinar", countryCode: "IQ" },
    { value: "BGN", label: "Bulgarian Lev", countryCode: "BG" },
    { value: "KGS", label: "Kyrgystani Som", countryCode: "KG" },
    { value: "RWF", label: "Rwandan Franc", countryCode: "RW" },
    { value: "BHD", label: "Bahraini Dinar", countryCode: "BH" },
    { value: "UZS", label: "Uzbekistan Som", countryCode: "UZ" },
    { value: "PKR", label: "Pakistani Rupee", countryCode: "PK" },
    { value: "MKD", label: "Macedonian Denar", countryCode: "MK" },
    { value: "AFN", label: "Afghan Afghani", countryCode: "AF" },
    { value: "NAD", label: "Namibian Dollar", countryCode: "NA" },
    { value: "BDT", label: "Bangladeshi Taka", countryCode: "BD" },
    { value: "AZN", label: "Azerbaijani Manat", countryCode: "AZ" },
    { value: "SOS", label: "Somali Shilling", countryCode: "SO" },
    { value: "QAR", label: "Qatari Rial", countryCode: "QA" },
    { value: "PAB", label: "Panamanian Balboa", countryCode: "PA" },
    { value: "CUC", label: "Cuban Convertible Peso", countryCode: "CU" },
    { value: "SVC", label: "Salvadoran Colon", countryCode: "SV" },
    { value: "SBD", label: "Solomon Islands Dollar", countryCode: "SB" },
    { value: "ALL", label: "Albanian Lek", countryCode: "AL" },
    { value: "BND", label: "Brunei Dollar", countryCode: "BN" },
    { value: "KWD", label: "Kuwaiti Dinar", countryCode: "KW" },
    { value: "GHS", label: "Ghanaian Cedi", countryCode: "GH" },
    { value: "ZMW", label: "Zambian Kwacha", countryCode: "ZM" },
    { value: "NTD", label: "New Taiwan Dollar", countryCode: "TW" },
    { value: "BYN", label: "Belarusian Ruble", countryCode: "BY" },
    { value: "CNH", label: "Chinese Yuan (Offshore)", countryCode: "CN" },
    { value: "MRU", label: "Mauritanian Ouguiya", countryCode: "MR" },
    { value: "STN", label: "Sao Tome and Principe Dobra", countryCode: "ST" },
    { value: "VES", label: "Venezuelan Bolivar Soberano", countryCode: "VE" },
    { value: "MXV", label: "Mexican Investment Unit", countryCode: "MX" },
    { value: "VED", label: "Venezuelan Bolivar Digital", countryCode: "VE" },
    { value: "SLE", label: "Sierra Leonean Leone", countryCode: "SL" }
];

module.exports = {currencyListOptions}
